import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '@ami/react/core';

const DealerUserSimpleTableRow = ({ dealerUser, onOpenEdit }) => {
  const { userId, fullName, email, dealerGroups, isRegistered, isRetired } =
    dealerUser;
  return (
    <tr>
      <td>
        {isRetired && <span>{fullName}</span>}
        {!isRetired && (
          <LinkButton
            id={userId}
            label={fullName}
            onClick={onOpenEdit.bind(userId)}
          />
        )}
      </td>
      <td>{email}</td>
      <td>{dealerGroups[0].dealerGroupName}</td>
      <td>{dealerGroups[0].defaultDealerBranchName}</td>
      <td>{isRegistered ? 'Yes' : 'No'}</td>
      <td>{isRetired ? 'Yes' : 'No'}</td>
    </tr>
  );
};

DealerUserSimpleTableRow.propTypes = {
  dealerUser: PropTypes.object.isRequired,
  onOpenEdit: PropTypes.func.isRequired,
};

export default DealerUserSimpleTableRow;
